{
  "todayButton": "I dag",
  "nextMonth": "Neste månad",
  "previousMonth": "Førre månad",
  "nextYear": "Neste år",
  "previousYear": "Førre år",
  "weekdays": [
    "Søndag",
    "Måndag",
    "Tysdag",
    "Onsdag",
    "Torsdag",
    "Fredag",
    "Laurdag"
  ],
  "months": [
    "Januar",
    "Februar",
    "Mars",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Desember"
  ]
}
